import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { IbaseService } from 'src/app/@shared/base-service/ibase-service';
import { MessageService } from 'src/app/@shared/message/message.service';
import { api } from 'src/app/@shared/services/api';
import { CommonService } from 'src/app/@shared/services/common.service';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-deposit',
  templateUrl: './deposit.component.html',
  styleUrls: ['./deposit.component.css']
})
export class DepositComponent implements OnInit {
  public api = api;
  public env = environment;
  private subs: Subscription[] = [];
  public data: any;
  // private uId: any;
  @Input() uId: any;
  @Output() closeModal = new EventEmitter();
  formData!: FormGroup;
  submitted = false;
  user: any = {};
  pa: any;

  constructor(public service: WebserviceService,
    private actRoute: ActivatedRoute,
    private _common: CommonService,
    private _message: MessageService,
    private fb: FormBuilder) {
    if (this.uId) {
      let pointAcc = (localStorage.getItem(`${this.env.panel}pointAcc`)) ? JSON.parse(localStorage.getItem(`${this.env.panel}pointAcc`) as any) : '';
      this.pa = (pointAcc && this.uId.slice(this.uId.length - 1) == 4) ? true : false;
    }
  }

  ngOnInit(): void {
    // this.uId = this.actRoute.snapshot.paramMap.get('uid');
    this.user = (localStorage.getItem(`${this.env.panel}user`)) ? JSON.parse(localStorage.getItem(`${this.env.panel}user`) as any) : '';
    this.formData = this.fb.group({
      deposit_chips: ['', Validators.required],
      parent_password: [''],
    });
    // this.getData();
  }

  getServices(): IbaseService<any> {
    return this.service;
  }



  getData() {
    // console.log(this.uId);
    this.uId = this.uId + "";
    let url = this.pa == true ? this.api.bankAccDeposit : this.api.amountDeposit;
    const sub1 = this.getServices().Get(`${this.env.baseUrl + this.api.user}/${this.uId.slice(0, -1) + url}`).subscribe(
      (res) => {
        if (res.status == true) {
          // res.data.statement.data = this._common.UTC_to_Local_timeZone(res.data.statement.data);
          this.data = res.data;
          if (this.data?.parent?.id != this.user?.id) {
            this.formData.controls['parent_password'].setValidators([Validators.required]);
          } else {
            this.formData.controls['parent_password'].clearValidators();
          }
          this.formData.controls['parent_password'].updateValueAndValidity();
        } else {
          if (res.error.code == 1003) {
            this._common.checkForForceChangePassword(res);
          } else {
            this._message.errmessage(res?.error?.message);
            this.cancel();
          }
        }
      },
      (err) => {
        console.log(err);
      });
    this.subs.push(sub1)
  }

  remainBal() {
    return (Number(this.data?.parent?.available_balance) - Number(this.formData.value.deposit_chips))
  }

  onSubmit() {
    // stop here if form is invalid
    if (this.formData.invalid) {
      return;
    }
    this.submitted = true;
    this.uId = this.uId + "";
    let url = this.pa == true ? this.api.bankAccDeposit : this.api.amountDeposit;
    const sub2 = this.getServices().Post(`${this.env.baseUrl + this.api.user}/${this.uId.slice(0, -1) + url}`, this._common.JSON_to_formData(this.formData.value)).subscribe(
      (res) => {
        if (res.status == true) {
          this._message.succmessage(res?.data?.message);
          this.closeModal.emit({ status: true, key: 'd' });
          this.formData.reset();
        } else {
          if (res.error.code == 1003) {
            this._common.checkForForceChangePassword(res);
          } else {
            this._message.errmessage(res?.error?.message);
          }
        }
        this.submitted = false;
      },
      (err) => {
        console.log(err);
        this.submitted = false;
      });
    this.subs.push(sub2)
  }

  cancel() {
    this.closeModal.emit({ status: false, key: 'd' });
    this.formData.reset();
  }

  trackByIndex(index: number, obj: any): any {
    return index;
  }

  // ngDoCheck() {
  //   if (this.uId != this.actRoute.snapshot.paramMap.get('uid')) {
  //     this.uId = this.actRoute.snapshot.paramMap.get('uid');
  //     this.getData();
  //   }

  // }

  ngOnChanges() {
    if (this.uId) {
      this.uId = this.uId + "";
      // this.uId = this.actRoute.snapshot.paramMap.get('uid');
      let pointAcc = (localStorage.getItem(`${this.env.panel}pointAcc`)) ? JSON.parse(localStorage.getItem(`${this.env.panel}pointAcc`) as any) : '';
      this.pa = (pointAcc && this.uId.slice(this.uId.length - 1) == 4) ? true : false;
      this.getData();
    }

  }

  ngOnDestroy() {
    this.subs.forEach((s) => s.unsubscribe());
  }

}
